export default class S3PutFileUploadError extends Error {
  constructor(public message: string) {
      super(message);
      Error.captureStackTrace(this, S3PutFileUploadError);
  }
}
